import React from 'react';

const defaultValues = {
  getName: name => name,
  isActive: a => a,
  isDisabled: d => d,
};

const FormFieldGroupContext = React.createContext(defaultValues);

export const FormIsolatedContext = props => (
  <FormFieldGroupContext.Provider value={defaultValues} {...props} />
);

export default FormFieldGroupContext;
